// Module
var code = "<button type=\"button\" class=\"btn\" ref=\"button\">\n    <i ref=\"icon\" aria-hidden=\"true\"></i>\n</button>";
// Exports
module.exports = code;